import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";

const Layout = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const isHomePage = location.pathname === "/";

  useEffect(() => {
    if (isHomePage) {
      document.body.classList.add("page-home");
    } else {
      document.body.classList.remove("page-home");
    }
    return () => {
      document.body.classList.remove("page-home");
    };
  }, [isHomePage]);

  return (
    <div className="flex flex-col min-h-screen w-full">
      <Header />

      <main className="flex-1 w-full">
        <Outlet />
      </main>

      <Footer />
    </div>
  );
};

export default Layout;
